<template>
    <div class="products-list">
        <div :class="handlerGrid()" :key="handlerGrid() + screenWidth">
            <div
                v-for="(item, index) in getItems"
                :key="item.id"
                :class="{
                    'big-image': item.type === 'two-item',
                    'advertising': item.type === 'two-item' || item.type === 'one-item',
                    'catalog-banner': item.type === 'banner',
                }"
            >
                <ProductCard
                    v-if="item.type !== 'banner'"
                    :result="item"
                    :messages="result.messages"
                    :dataLayer="result.dataLayer"
                />
                <div v-else-if="item.size % 2 === 0 && even">
                    <a :href="even.link">
                        <div v-if="even.html">
                            <DefInsertTildaSlider :result="even.html"/>
                        </div>
                        <DefVideo
                            v-else-if="even.video"
                            :result="even.video"
                        />
                        <DefPicture
                            v-else
                            :result="even.animation || even.pictures"
                        />
                    </a>
                </div>
                <div v-else-if="odd">
                    <a :href="odd.link">
                        <div v-if="odd.html">
                            <DefInsertTildaSlider :result="odd.html"/>
                        </div>
                        <DefVideo
                            v-else-if="odd.video"
                            :result="odd.video"
                        />
                        <DefPicture
                            v-else
                            :result="odd.animation || odd.pictures"
                        />
                    </a>
                </div>
            </div>
        </div>
        <Pagination
            :result="result.pagination"
            :messages="showMore ? showMore.messages : undefined"
            @change="handlerChangePage"
            @addMore="getMoreItems"
        />
    </div>
</template>
<script>
import { mapActions } from 'vuex';

import DefInsertTildaSlider from "../def/DefInsertTilda/DefInsertTildaSlider";

export default {
    name: 'ProductsList',
    props: {
        result: {
            type: Object,
            default: () => items
        },
        catalogListShow: Number,
        showMore: {
            type: Object
        },
    },
    components: {
        DefInsertTildaSlider,
    },
    data() {
        return {
            pageNumberStart: 1,
        }
    },
    methods: {
        ...mapActions({
            changePageData: 'catalog/changePageData',
            getMoreItems: 'catalog/getMoreItems',
        }),
        handlerChangePage(e) {
            this.saveStartPage();
            this.changePageData(e);
        },

        handlerGrid() {
             if (this.catalogListShow === 4) {
                 return 'products-list_four';
             } else if (this.catalogListShow === 3) {
                 return 'products-list_three';
             } else if (this.catalogListShow === 2) {
                 return 'products-list_two';
             }
             return 'products-list_items';
        },

        saveStartPage() {
            const start = +this.$route.query[ this.result?.pagination?.pagingKey ];

            if (start) {
                this.pageNumberStart = start;
            }
        },
    },
    computed: {
        odd() {
            return this.result?.banners?.odd?.[0];
        },
        even() {
            return this.result?.banners?.even?.[0];
        },
        getItems() {
            try {
                const { pageSize, pagingKey } = this.result.pagination;
                let bannerPosition = 6;
                const newArr = [];

                if (this.catalogListShow === 4) {
                    bannerPosition = 8;
                }

                this.result.items.forEach((el, i) => {
                    if (
                        i === bannerPosition ||
                        (i % (bannerPosition + pageSize)) === 0 &&
                        i !== 0
                    ) {
                        let bannerCount = Math.floor(i / (bannerPosition + pageSize));
                        let size = (+this.$route.query[ pagingKey ] || 1) + bannerCount;

                        if (this.result.items.length > pageSize) {
                            size = this.pageNumberStart + bannerCount;
                        }

                        if (size % 2 === 0 && this.even) {
                            newArr.push({ type: 'banner', size });
                        } else if (this.odd) {
                            newArr.push({ type: 'banner', size });
                        }

                    }
                    newArr.push(el);
                });

                return newArr;
            } catch (err) {
                console.error(err);
                return this.items;
            }

        },
    },
    created() {
        this.saveStartPage();
    },
}
</script>

<style lang="scss">
.products-list{
    &_items{
        display: grid;
        grid-gap: 4px;
        grid-template-columns: minmax(0, 1fr);
        @include point-md{
            grid-template-columns: repeat(3, 1fr);
        }
        //@include grid(1, 4, 4);
        //@include grid-md(3, 4, 4);
        .big-image{
            width: 100%;
        }
        .catalog-banner{
            grid-column: span 1;
        }
    }
    &_two{
        display: grid;
        grid-gap: 4px;
        grid-template-columns: repeat(2, 1fr);
        @include point-md{
            grid-template-columns: repeat(3, 1fr);
        }
        //@include grid(2, 4, 4);
        //@include grid-md(3, 4, 4);
        .big-image{
            width: 100%;
        }
    }
    &_three{
        display: grid;
        grid-gap: 4px;
        grid-template-columns: repeat(2, 1fr);
        @include point-md{
            grid-template-columns: repeat(3, 1fr);
        }
        //@include grid(2, 4, 4);
        //@include grid-md(3, 4, 4);
        //
        //.wrap{
        //        width: calc(33.3% - 4px);
        //        margin-right: 4px;
            .big-image{
                width: 66.1%;
            }
        //}
    }
    &_four{
        display: grid;
        grid-gap: 4px;
        grid-template-columns: repeat(2, 1fr);;
        @include point-md{
            grid-template-columns: repeat(4, 1fr);
        }
        //@include grid(2, 4, 4);
        //@include grid-md(4, 4, 4);
        //
        //.wrap{
        //        width: calc(25% - 4px);
        //        margin-right: 4px;
            .big-image{
                width: 49.7%;
            }
        //}
    }
}
.advertising{
    &:hover{
        div .product-card__view {
            opacity: 0;
        }
    }
}
.catalog-banner{
    grid-column: span 2;
}
</style>
